// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"edaf469806b2a30092c2","293":"93fe9066992e268a2add","518":"1c05ee34fde428b72f2b","779":"bd2db49126dcd4d2539d"}[chunkId] + ".js";
};